import React from "react";
import PortfolioContent from "./components/PortfolioContent";

const App = () => <PortfolioContent />;

export default App;
